// extracted by mini-css-extract-plugin
export var currencyInput = "_m3-1";
export var currencySymbol = "_m3-0";